import { EMPTY_OBJECT } from '../../../../constants/common'
import { GretaAIChatChatActionType } from '../../GretaAIChat.constants'
import { GretaAIChatDeleteConfirmation } from '../../GretaAIChatDeleteConfirmation'
import { GretaAIChatRenameModal } from '../../GretaAIChatRenameModal'

export function getGretaAIChatPanelChatActionContent({
  chatAction,
  t,
  onCancel,
  onConfirmDelete,
  onConfirmRename,
}) {
  const { chat, type } = chatAction ?? EMPTY_OBJECT

  switch (type) {
    case GretaAIChatChatActionType.Rename:
      return (
        <GretaAIChatRenameModal
          errorText={t('Greta.StatusErrorKey')}
          name={chat.title || t('Greta.NewChatKey')}
          placeholder={t('Greta.ChatNamePlaceholderKey')}
          title={t('Greta.RenameChatTitleKey')}
          onCancel={onCancel}
          onSubmit={onConfirmRename}
        />
      )
    case GretaAIChatChatActionType.Delete:
      return (
        <GretaAIChatDeleteConfirmation
          onCancel={onCancel}
          onConfirm={onConfirmDelete}
        />
      )
    default:
      return null
  }
}
